import Vue from 'vue'
import http from '../http'
import CONFIG from '../config'
Vue.prototype.GFH_HTTP = http;

Vue.mixin({
    methods: {
        GFH_POST(urlKey, params = {}, options = {}) {
            options.suffix = CONFIG.SUFFIX;
            return this.GFH_HTTP.POST(urlKey, params, options);
        },

    }
})